import React, { Component } from "react";

class NoMatch extends Component {
  static contextTypes = {
    router: () => true // replace with PropTypes.object if you use them
  };

  render() {
    return (
      <div className="container">
        <center>
          <h1 className="four-h1">404</h1>
          <div className="four-text"> OOPS! SORRY WE CAN'T FIND THAT PAGE!</div>
          <button className="btn btn-default" onClick={this.context.router.history.goBack}>
            Go Back
          </button>
        </center>
      </div>
    );
  }
}

export default NoMatch;



// WEBPACK FOOTER //
// ./src/containers/User/Common/NoMatch/NoMatch.js